import React from 'react';
import { ReactComponent as Logo } from 'src/assets/shs_logo_2026.svg';

const ShsLogo: React.FC = () => {
    return (
        <div style={{ width: '250px' }}>
            <Logo />
        </div>
    );
};

export default ShsLogo;
